import PropTypes from 'prop-types'
import { NavLink as RouterLink } from 'react-router-dom'
import { Box, List, ListItemText } from '@mui/material'
import { StyledNavItem } from './styles'
import React from 'react'

NavSection.propTypes = {
  data: PropTypes.array
}

export default function NavSection ({ data = [], ...other }: any) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item: any) => (
          <NavItem key={item.title} item={item}></NavItem>
        ))}
      </List>
    </Box>
  )
}

NavItem.propTypes = {
  item: PropTypes.object
}

function NavItem ({ item }: any) {
  const { title, path, info } = item

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold'
        }
      }}
    >
      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  )
}
